import { useEffect } from "react"
import { IBackgroundProps } from "../Background"

/* https://codepen.io/giaco/pen/jOOGjPE */
/* Protopia Ecosystem component */
export interface IBackgroundHexagonalMeshProps {
   
}
const BackgroundHexagonalMesh = ({section, ...props}: IBackgroundProps): JSX.Element => {
    const bg = section.background
    const color = bg.color
    const color2 = bg.color2
    useEffect(() => {
        const canvas: HTMLCanvasElement = document.getElementById('canvas')! as HTMLCanvasElement;
        let R = 360;
        let yoffset = Math.sqrt(3) / 2 * R;
        let xoffset = 3 * R / 2;
        let ctx: CanvasRenderingContext2D = canvas.getContext("2d")!;
        let cw = (canvas.width = window.innerWidth);
        let ch = (canvas.height = window.innerHeight);
        let cx = cw / 2,
        cy = ch / 2;

        let rid: any = null;
        let frames = 1.57;
        let stopped = true;
        let maxAngle = .1;

        function draw() {
            rid = window.requestAnimationFrame(draw);
            ctx.clearRect(0, 0, cw, ch);
            let n = 0;
            for (let Y = 0; Y <= ch + R; Y += yoffset) {
                let left = n % 2 === 0 ? 1.5 * R : 0;
                for (let X = left; X <= cw + R; X += 2 * xoffset) {
                group(X, Y, R, maxAngle * Math.sin(frames));
                }
                n++;
            }
            frames += 0.01;
        }

        function Init() {
            if (rid) {
                window.cancelAnimationFrame(rid);
            }
            cw = canvas.width = window.innerWidth;
            ch = canvas.height = window.innerHeight;
            //(cx = cw / 2), (cy = ch / 2);
            ctx.lineWidth = 3;
            ctx.strokeStyle = color2;
            draw();
            !!stopped ? stopAnimation() : start();
        }

        function hex(X: number, Y: number, R: number, rot: any) {
            ctx.beginPath();
            ctx.lineJoin = "round";
            for (let i = 0; i < 6; i++) {
                let x = X + R * Math.cos(rot + i * (Math.PI / 3));
                let y = Y + R * Math.sin(rot + i * (Math.PI / 3));
                ctx.lineTo(x, y);
            }
            ctx.closePath();
            ctx.stroke();
        }

        function group(X: number, Y: number, R: number, rot: any) {
            for (let j = 0; j <= 10; j++) {
                let r = R - j * (R / 16);
                hex(X, Y, r, j * rot);
                if (j === 10) {
                    ctx.fillStyle =  color;
                    ctx.fill();
                }
            }
        }

        const timer = window.setTimeout(function() {
            Init();
            window.addEventListener("resize", Init, false);
        }, 15);

        function start() {
            if (!rid) {
                rid = window.requestAnimationFrame(draw);
            }
            stopped = false;
        }
        function stopAnimation() {
            if (rid) {
                window.cancelAnimationFrame(rid);
            }
            rid = null;
            stopped = true;
        }
        canvas.addEventListener(
            "click",
            function() {
                !!stopped ? start() : stopAnimation();
            },
            false
        );
        return () => clearTimeout(timer)
    }, [])

    return <div className='pe-background-hexagonal-mesh' style={{
        background: color || "#00222B",
        filter: "blur(6px)",
        width: "100%",
        height: "100%",
        position: "absolute",
        top:0,
        left:0,

    }}>
       <canvas id="canvas"></canvas>
    </div>
}
export default BackgroundHexagonalMesh
